import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-at-risk",
  "use": "icon-at-risk-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-at-risk\">\n<circle cx=\"8\" cy=\"8\" r=\"5\" fill=\"#D1523A\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol